export enum EnumTicketStatus {
  CLOSED = 'closed',
  OPEN = 'open',
  IN_PROGRESS = 'in-progress',
}